import { Flex, VStack } from '@chakra-ui/react';
import { TemplateFilters } from 'hooks/usePaginatedTemplatesSearch/usePaginatedTemplatesSearch.types';

import { TemplatesFilterInput } from './TemplatesFilterInput';
import { TemplatesFilterTags } from './TemplatesFilterTags';
import { TemplatesSearchInput } from './TemplatesSearchInput';

/**
 * TEMPLATES SEARCH COMPONENT
 *
 * Renders search input and filters list for templates
 */
interface TemplatesSearchProps {
  query: string;
  onSearch: (query: string) => void;
  filters: TemplateFilters | null;
  setFilters: (filters: TemplateFilters) => void;
}

export const TemplatesSearch = ({ onSearch, filters, setFilters, query }: TemplatesSearchProps) => {
  return (
    <VStack align='flex-end' p={2} gap={2} w='full'>
      <Flex w='full' gap={2}>
        <TemplatesSearchInput onSearch={onSearch} query={query} />
        <TemplatesFilterInput appliedFilters={filters} applyFilters={setFilters} />
      </Flex>
      <TemplatesFilterTags appliedFilters={filters} applyFilters={setFilters} />
    </VStack>
  );
};
